import cfg from './configuration/PropertiesConfiguration'
export class PersonalTrainingService {
  constructor (axios) {
    this.axios = axios
  }

  getPersonalTraining (config) {
    return this.axios.get(cfg.personalTraining, config, {useCache: true})
  }
}



// WEBPACK FOOTER //
// ./src/services/PersonalTrainingService.js